// Core
import React from 'react';

// Hooks
import { useOverflowTooltip } from '../../../hooks/useOverflowTooltip/useOverflowTooltip';
import { useBreakpoint } from '../../../hooks/useBreakpoint';

// Components
import {
  Paragraph,
  ParagraphSize,
  ParagraphWeight,
} from '../Paragraph';
import { Tooltip, TooltipPlacement } from '../Tooltip';
import { CaretRight } from '../../icons';

// Component
import {
  Container,
  ContentContainer,
  Element,
  IconContainer,
  TitleContainer,
} from './ModuleHeader.style';
import { ModuleHeaderProps } from './ModuleHeader.types';

function ModuleHeader({
  className,
  onClick,
  testId,
  title,
}: ModuleHeaderProps): JSX.Element {
  const {
    containerRef,
    contentRef,
    isTooltipVisible,
  } = useOverflowTooltip({ overflowCheckTriggers: title });

  const { isXs } = useBreakpoint();

  return (
    <Container data-testid={testId} className={className}>
      <Element tabIndex={0} onClick={onClick} role="button">
        <TitleContainer ref={containerRef}>
          {isTooltipVisible ? (
            <Tooltip text={title} placement={TooltipPlacement.top}>
              <ContentContainer ref={contentRef}>
                <Paragraph
                  weight={ParagraphWeight.bold}
                  size={isXs ? ParagraphSize.sm : ParagraphSize.md}
                  preventOverflow
                >
                  {title}
                </Paragraph>
              </ContentContainer>
            </Tooltip>
          ) : (
            <ContentContainer ref={contentRef}>
              <Paragraph
                weight={ParagraphWeight.bold}
                size={isXs ? ParagraphSize.sm : ParagraphSize.md}
                preventOverflow
              >
                {title}
              </Paragraph>
            </ContentContainer>
          )}
        </TitleContainer>
        <IconContainer>
          <CaretRight />
        </IconContainer>
      </Element>
    </Container>
  );
}

export { ModuleHeader };
